export default __webpack_public_path__ + "static/media/finish.e7c3f551.mp3";